// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-hightlight-area-module__highlightArea--3jm95{box-sizing:border-box;padding:15px;background-color:#eff3fe}", ""]);
// Exports
exports.locals = {
	"highlightArea": "comment-hightlight-area-module__highlightArea--3jm95"
};
module.exports = exports;
